import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { useEffect, useState } from "react";
import { Outlet, Route, Routes, useParams } from "react-router-dom";
import Heading from "../../components/Heading/Heading";
import axiosGet from "../../helpers/axiosGet";
import DataTableBundle from "../../components/DataTable/DataTableBundle";

export default function BundleCargoList() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<ListDeclaration />} />
      </Route>
    </Routes>
  );
}

function Layout() {
  return (
    <>
      <Heading>BUNDLE LIST</Heading>

      <Outlet />
    </>
  );
}

function ListDeclaration() {
  const { uniqId } = useParams();
  const [dataBundle, setDataBundle] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalPage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);

  const fetchData = (pageNumber) => {
    setLoading(true);
    setError(null);

    axiosGet({
      url: `polismall-claim-cargo/bundle/declaration/list/uniq-id/${uniqId}/page/${pageNumber}`,
      callback: (res) => {
        setLoading(false);
        setDataBundle(res.data.data);
        setTotalPage(res.data.totalPage);
        setPage(res.data.page);
      },
      errorCallback: (err) => {
        setLoading(false);
        setError(err);
        console.error(err);
      },
    });
  };

  useEffect(() => {
    fetchData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uniqId]);

  const headers = [
    {
      name: (
        <>
          <div>Certificate Number</div>
          <div>Policy Number</div>
        </>
      ),
    },
    {
      name: "Insured",
    },
    {
      name: (
        <>
          <div>Port Loading</div>
          <div>Port Destination</div>
        </>
      ),
    },

    {
      name: "Action",
    },
  ];

  const handlePage = (selectedItem) => {
    const selectedPage = selectedItem.selected + 1;
    fetchData(selectedPage);
  };

  return (
    <div>
      <MDBRow>
        <MDBCol md="12">
          <DataTableBundle
            rows={dataBundle}
            headers={headers}
            loading={loading}
            error={error}
            page={page}
            totalPage={totalPage}
            handlePage={handlePage}
          />
        </MDBCol>
      </MDBRow>
    </div>
  );
}
